// import clone from 'clone';
import actions from './actions';
const initState = {
  asset: {},
  assets: [],
  rawAssets: [],
  isSaved: false,
  isDelete: false,
  isLoading: false,
  isPrintLoading: false,
  assetName: '',
  assetId: null,
  printData: null,
  assetNumber: null,
  supplies:[]
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.ADD_SUCCESS:
      return {
        ...state,
        assetName: action.asset.strName,
        assetId: action.asset.id,
        isSaved: true,
        isPrintLoading: false
      };
    case actions.ADD_FAILED:
      return {
        ...state,
        assets: [],
        rawAssets: [],
        isSaved: true,
        isPrintLoading: false
      };
    case actions.GET_ASSET_REDUCER: {
      return {
        ...state,
        assets: action.assets,
        rawAssets: action.assets,
        isLoading: true,
        isDelete: false,
        assetName: '',
        isSaved: false,
        isPrintLoading: false
      };
    }
    case actions.GET_ASSET_BYID_REDUCER: {
      return {
        ...state,
        asset: action.asset,
        isDelete: false,
        isSaved: false,
        isPrintLoading: false
      };
    }
    case actions.GET_PRINT_DATA_BY_ID: {
      return {
        ...state,
        printData: action.asset,
        isDelete: false,
        isSaved: false,
        isPrintLoading: true
      };
    }
    case actions.UPDATE_SUCCESS:
      return {
        ...state,
        isDelete: false,
        isSaved: true,
        isPrintLoading: false
      };
    case actions.DELETE_FAILED:
      return {
        ...state,
        isDelete: false,
      };
    case actions.DELETE_SUCCESS:
      return {
        ...state,
        isDelete: true,
        isSaved: false,
        isPrintLoading: false
      };
    case actions.CREATE_NUMBER_SUCCESS:
      return {
        ...state,
        isDelete: false,
        isSaved: false,
        assetNumber: action.assetNumber,
        assetId: action.assetNumber,
        isPrintLoading: false
      };
    case actions.GET_SUPPLIY_REDUCER:
      return {
        ...state,
        supplies: action.data,
        isLoading: true,
        isDelete: false,
        isSaved: false,
        isPrintLoading: false
      };
    default:
      return state;
  }
}
